import PurchaseScreenTypePlan from '../enums/PurchaseScreenTypePlan';
import UpsellTrigger from '../enums/UpsellTrigger';
import { getAmplitudeInstance } from '../amplitudeHelpers';

type logUpsellMidpointShownParams = {
  purchase_screen_type_plan?: PurchaseScreenTypePlan;
  trigger?: UpsellTrigger;
};

/**
 * User reaches the midpoint of the upsell, defined as row 8 in the comparison table, after beginning to scroll beneath the fold.
 * @param params - Attributes to log with the amplitude event
 * @param params.purchase_screen_type_plan - The plan shown on the pro purchasing event occurs on (e.g. trial, non-trial, promo, etc.)
 * @param params.trigger - Action that triggered the upsell to display
 */
const logUpsellMidpointShown = ({ purchase_screen_type_plan, trigger }: logUpsellMidpointShownParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('upsell midpoint shown', { 'purchase screen type plan': purchase_screen_type_plan, trigger }, callback);
};

export default logUpsellMidpointShown;
